//Vue and associated pieces
import axios from "axios";
import * as moment from 'moment';
import Vue from 'vue';
import VueAnalytics from 'vue-analytics';
import VueBreadcrumbs from 'vue-breadcrumbs';
import inEU from '@segment/in-eu';

import store from './store';
import router from "./routes";
import App from "./App";

Vue.component('app', App);

Vue.use(VueAnalytics, {
    id: 'UA-48125195-3',
    router,
    disabled: inEU()? localStorage.getItem("vue-cookie-accept-decline-heat-tracking") !== 'accept' : false,
    debug: {
        enabled: false
    },
    set: [
        { field: 'anonymizeIp', value: inEU() }
    ]
});

Vue.use(VueBreadcrumbs, {
    template: '<nav class="breadcrumb" v-if="$breadcrumbs.length"> ' +
    '<ul> ' +
    '<li v-for="(crumb, index) in $breadcrumbs"> ' +
    '<router-link :to="linkProp(crumb)">{{ crumb | crumbText }}</router-link> ' +
    '</li> ' +
    '</ul> ' +
    '</nav>'
});

/**
 * Reload the page if axios starts giving permission errors after an hour.
 *
 * This is normally because their session has timed out
 */
axios.interceptors.response.use(function (response) {
    return response;
}, async function (error) {
    //Short circuit loop on initial page load
    if (store.state.loaded === null) {
        return Promise.reject(error);
    }

    let errorUrl = new URL(error.request.responseURL);

    // make sure it's a permission error accessing our own site
    if (window.location.host === errorUrl.host && (error.response.status === 401 || error.response.status === 403)) {
        if (moment().diff(store.state.loaded, 'hours') >= 1) {
            router.go(0);  //Triggers a full page reload
        }
    }

    return Promise.reject(error);
});

window.app = new Vue({
    el: '#app',
    store,
    router,
});
